import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="mt-8 mb-20 px-4">
    <div className="mx-auto max-w-lg md:max-w-3xl lg:max-w-5xl">
      {/* Footer Links */}
      <nav aria-label="Footer navigation" className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground mb-4">
        <Link to="/about" className="underline underline-offset-2 hover:text-foreground">About Us</Link>
        <span aria-hidden="true">·</span>
        <Link to="/articles" className="underline underline-offset-2 hover:text-foreground">Guides</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" className="underline underline-offset-2 hover:text-foreground">Privacy Policy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/terms" className="underline underline-offset-2 hover:text-foreground">Terms of Service</Link>
        <span aria-hidden="true">·</span>
        <Link to="/contact" className="underline underline-offset-2 hover:text-foreground">Contact</Link>
        <span aria-hidden="true">·</span>
        <Link to="/accessibility" className="underline underline-offset-2 hover:text-foreground">Accessibility Commitment</Link>
      </nav>

      {/* Accessibility Commitment */}
      <div className="mb-4 rounded-xl bg-card p-4 shadow-sm">
        <h2 className="text-sm font-bold text-foreground mb-2">♿ Accessibility Commitment</h2>
        <p className="text-xs leading-relaxed text-muted-foreground">
          Sweet Baby Bloom is committed to ensuring digital accessibility for all users, including parents and caregivers with disabilities. We follow{" "}
          <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.1 Level AA standards and continuously improve the user experience for everyone. Our app uses semantic HTML, descriptive alt text, ARIA labels for interactive elements, keyboard-navigable interfaces, and sufficient color contrast ratios. If you encounter any accessibility barriers, please{" "}
          <Link to="/contact" className="font-semibold text-primary underline underline-offset-2">contact us</Link> so we can assist you.
        </p>
      </div>

      <p className="text-center text-[10px] text-muted-foreground/60">
        © {new Date().getFullYear()} Sweet Baby Bloom. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
